import { StatsPipe } from './../../shared/pipes/stats.pipe';
import { ErrorService } from './../../services/error.service';
import { NostosService } from './../../services/nostos.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { LoadingSpinnerDialogComponent } from '../../dialogs/loading-spinner/loading-spinner-dialog.component';
import { finalize } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { Template } from '../../models/template';
import { Confirmation } from '../../models/confirmation';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation/confirmation-dialog.component';
import { TemplateDialogComponent } from '../../dialogs/template/template-dialog.component';

@Component({
  selector: 'app-templates',
  standalone: true,
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.css',
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    DatePipe,
    MatIconModule,
    StatsPipe
  ],
  providers: [StatsPipe]
})
export class TemplatesComponent implements OnInit {

  displayedColumns: string[] = [
    'name',
    'description',
    'userId',
    'content',
    'updateTs',
    'controls'
  ];
  dataSource = new MatTableDataSource<Template>([]);
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private statsPipe: StatsPipe, private errorService: ErrorService, private clipboard: Clipboard, private nostosService: NostosService, private dialog: MatDialog) { }

  ngOnInit() {

    this.load();

  }

  load() {

    const dialogRef = this.dialog.open(LoadingSpinnerDialogComponent, {
      disableClose: true,
      panelClass: 'loading-dialog'
    });

    this.nostosService.getTemplates().pipe(finalize(() => { dialogRef.close(); })).subscribe({
      next: instances => {
        this.dataSource.data = instances;
        this.dataSource.sort = this.sort;
      }
    });

  }

  toDate(seconds: number | null | undefined): Date | null {
    if (seconds == 0) return null;
    return seconds ? new Date(seconds * 1000) : null;
  }

  toDateTs(utcString: string | null | undefined): Date | null {

    if ((utcString) && (utcString.length > 0)) {
      return new Date(utcString.endsWith("Z") ? utcString : utcString + "Z");
    }
    return null;

  }

  addTemplate() {

    console.log("addTemplate called");

    var theTemplate: Template = {
      templateId: "",
      userId: "",
      name: "",
      description: "",
      templateTypeId: "",
      test: "",
      eval: "",
      createTs: "",
      updateTs: ""
    }

    const dialogRef = this.dialog.open(TemplateDialogComponent, {
      minWidth: '800px',
      data: {
        template: theTemplate
      },
    });

    dialogRef.afterClosed().subscribe((newTemplate: Template | undefined) => {

      if (newTemplate) {
        this.nostosService.addTemplate(newTemplate).subscribe({
          next: () => {
            this.reload();
          }
        });
      }
    });

  }

  updateTemplate(template: Template) {

    const clone = structuredClone(template);

    const dialogRef = this.dialog.open(TemplateDialogComponent, {
      minWidth: '800px',
      data: {
        template: clone
      },
    });

    dialogRef.afterClosed().subscribe((newTemplate: Template | undefined) => {

      if (newTemplate) {
        this.nostosService.updateTemplate(newTemplate).subscribe({
          next: () => {
            this.reload();
          }
        });
      }
    });

  }

  deleteTemplate(id: string) {

    var theConfirm: Confirmation = {
      title: "Confirm Delete",
      message: "Really delete the selected template?",
      isOkay: false
    };

    const confirmRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        confirmation: theConfirm
      },
    });

    confirmRef.afterClosed().subscribe((selection: Confirmation | undefined) => {

      if (selection) {
        this.nostosService.deleteTemplate(id).subscribe({
          next: () => {
            this.load();
          }
        });
      }

    });

  }

  copyToClipboard(theTemplate: Template) {

    var theXml = this.statsPipe.transform(theTemplate);
    this.clipboard.copy(theXml);
    this.errorService.showMessage("Content copied to the clipboard");

  }

  reload() {

    this.load();

  }

}
